<script setup>
import {useDisplay} from "vuetify";

const { smAndDown } = useDisplay();
const model = defineModel({type: String});

const letters = [];
for (let i = 0; i < 26; i++) {
    letters.push(String.fromCharCode(65 + i));
}

function selectLetter(letter) {
    model.value = letter;
}

function isSelected(letter) {
    return model.value === letter;
}
</script>

<template>
    <div class="prefix-keypad">
        <div class="prefix-keypad__letters">
            <v-btn v-for="letter in letters" :key="'k' + letter"
                   type="button"
                   class="prefix-keypad__button"
                   rounded="sm"
                   :variant="isSelected(letter) ? 'flat' : 'tonal'"
                   :size="smAndDown ? 'small' : 'large'"
                   :height="smAndDown ? 44 : 52"
                   :ripple="false"
                   @click="selectLetter(letter)">
                {{ letter }}
            </v-btn>
        </div>
    </div>
</template>
